export const MENU_TYPE_NAME = {
    ProgramSupport: "ProgramSupport",
    DesignSupport: "DesignSupport",
    Inquiry: "Inquiry",
    Notifications: "Notifications",
    Home: "Home",
    ProgramDesign: "ProgramDesign",
    ProgramAdmin: "ProgramAdmin",
    Settings: "Settings",
    CPRAdmin: "CPRAdmin",
    ManageAccount: "ManageAccount",
    PrivacyPolicy: "PrivacyPolicy",
    TermsOfUse: "TermsOfUse"
    // NewMenuToggle: "NewMenuToggle" - DEPRECATED
};

// this should not be a full copy of PowerClerkPage, just the pages that need
// to be referenced explicitly
export const MENU_PAGE_NAME = {
    ManageAccount: "ManageAccount"
};
